/**
 * Serviço centralizado para a Central de Atendimento.
 * Todas as chamadas usam REACT_APP_BACKEND_URL + /api/central.
 */
import axios from 'axios';
const API = `${process.env.REACT_APP_BACKEND_URL}/api/central`;

export const centralApi = {
  dashboard: () => axios.get(`${API}/dashboard`).then(r => r.data),

  listConversations: (params = {}) =>
    axios.get(`${API}/conversations`, { params }).then(r => r.data),
  getConversation: (id) => axios.get(`${API}/conversations/${id}`).then(r => r.data),
  createConversation: (body) => axios.post(`${API}/conversations`, body).then(r => r.data),
  assumeConversation: (id) => axios.patch(`${API}/conversations/${id}/assume`).then(r => r.data),
  returnToAi: (id) => axios.patch(`${API}/conversations/${id}/return-to-ai`).then(r => r.data),
  closeConversation: (id) => axios.patch(`${API}/conversations/${id}/close`).then(r => r.data),
  markRead: (id) => axios.patch(`${API}/conversations/${id}/read`).then(r => r.data),

  listMessages: (id, params = {}) =>
    axios.get(`${API}/conversations/${id}/messages`, { params }).then(r => r.data),
  sendMessage: (id, body) =>
    axios.post(`${API}/conversations/${id}/messages`, body).then(r => r.data),

  getCustomerPanel: (id) =>
    axios.get(`${API}/conversations/${id}/customer-panel`).then(r => r.data),

  getWaiting: () => axios.get(`${API}/waiting`).then(r => r.data),

  listKnowledge: (categoria) =>
    axios.get(`${API}/knowledge`, { params: categoria ? { categoria } : {} }).then(r => r.data),
  createKnowledge: (body) => axios.post(`${API}/knowledge`, body).then(r => r.data),
  updateKnowledge: (id, body) => axios.put(`${API}/knowledge/${id}`, body).then(r => r.data),
  deleteKnowledge: (id) => axios.delete(`${API}/knowledge/${id}`).then(r => r.data),

  getAiSettings: () => axios.get(`${API}/ai/settings`).then(r => r.data),
  updateAiSettings: (body) => axios.put(`${API}/ai/settings`, body).then(r => r.data),

  getWaSettings: () => axios.get(`${API}/whatsapp/settings`).then(r => r.data),
  updateWaSettings: (body) => axios.put(`${API}/whatsapp/settings`, body).then(r => r.data),
  testWaConnection: () => axios.post(`${API}/whatsapp/test-connection`).then(r => r.data),

  // Baileys (QR Code)
  getBaileysStatus: () => axios.get(`${API}/whatsapp/baileys/status`).then(r => r.data),
  resetBaileys: () => axios.post(`${API}/whatsapp/baileys/reset`).then(r => r.data),
  disconnectBaileys: () => axios.post(`${API}/whatsapp/baileys/disconnect`).then(r => r.data),

  seedDemo: () => axios.post(`${API}/demo/seed`).then(r => r.data),
  resetDemo: () => axios.delete(`${API}/demo/reset`).then(r => r.data),
};

/**
 * Banner "Modo demonstração — dados simulados".
 * `when` controla exibição: passe false quando a integração real estiver ativa.
 */
export const DemoBanner = ({ when = true }) => {
  if (when === false) return null;
  return (
    <div className="rounded-md border border-amber-500/40 bg-amber-500/10 text-amber-700 dark:text-amber-400 px-3 py-2 text-xs font-medium flex items-center gap-2 mb-3">
      <span className="h-2 w-2 rounded-full bg-amber-500 animate-pulse" />
      Modo demonstração — dados simulados
    </div>
  );
};
